var objectFitImages = require('object-fit-images');

(function($) {
	objectFitImages('.img--objectfit');
})(jQuery); // Fully reference jQuery after this point.
